import { jsonp } from '@ifeng-fe/ui_base';
import { formatHotListData } from '../utils/formatComment.js';

// apiUrl为webpack注入的全局变量
/* eslint-disable */
let apiBaseUrl = apiUrl;

/* eslint-enable */

if (typeof window === 'object' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

/**
 * 获取用户评论列表
 * @param {String} user_id user id
 * @param {Number} p page
 * @param {Number} pagesize pagesize
 */
export const getUserComments = async (user_id, p, pagesize = 20) => {
    try {
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';

        const data = await jsonp(`//${commentDomain}/get/usercomments`, {
            data: {
                user_id,
                p,
                pagesize,
                format: 'js',
            },
            jsonpCallback: 'getUserComments',
            cache: false,
        });

        data.comments = formatHotListData(data.comments);

        return data;
    } catch (e) {
        console.error(e);

        return { count: 0, join_count: 0, comments: [] };
    }
};

/**
 * 获取用户 guid
 * @param {String} sid sid
 */
export const getGuid = async sid => {
    const guid = await jsonp('//id.ifeng.com/api/getuid', {
        data: {
            sid,
        },
        cache: true,
    });

    return guid;
};

/**
 * 提交评论
 * @param {Object} content 评论内容
 * @param {Object} config 评论配置
 */
export const postComment = async (content, config) => {
    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';

    const data = await jsonp(`//${commentDomain}/post`, {
        data: config.quote_id
            ? {
                  doc_url: config.docUrl,
                  docName: config.docTitle,
                  content,
                  skey: config.skey,
                  from: 'pc',
                  quote_id: config.quote_id,
                  format: 'js',
              }
            : {
                  doc_url: config.docUrl,
                  docName: config.docTitle,
                  content,
                  skey: config.skey,
                  from: 'pc',
                  format: 'js',
              },
        jsonpCallback: 'postCmt',
        cache: false,
    });

    return data;
};

/**
 * 获取评论日周排行
 */
export const getDayWeeklyRankComment = async () => {
    try {
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';

        return await jsonp(`//${commentDomain}/get/dayweekrank`, {
            data: {
                format: 'js',
            },
            jsonpCallback: 'getHotRank',
            cache: false,
        });
    } catch (e) {
        console.error(e);

        return { dayTop: [], weekTop: [] };
    }
};
